import React from 'react';
import { BiLoggerContextProvider } from '@wix/da-bi/pkg/BiLogger.context';
import BrowseThumbLayout from '../../../BrowseThumbLayout';
import ContentLoader from '../../../ContentLoader';
import Strips from '../../../Strips';
import FeedLayout from '../../../FeedLayout';
import { BrowseItem } from '../../../../../types/api';

export interface Props {
  initialOffset?: number;
  feedType?: string;
  contentStrip?: React.ReactNode;
  contentStripIndex?: number;
  contentStripHeight?: number;
  getItemUrl?: (item: BrowseItem) => string | undefined;
}

const DefaultPageContent: React.FC<Props> = ({
  initialOffset,
  feedType,
  contentStrip,
  contentStripIndex,
  contentStripHeight,
  getItemUrl,
}) => {
  const isPostFeed = feedType === 'posts';

  return (
    <BiLoggerContextProvider
      value={{
        sectionname: 'general',
        _rankOffset: initialOffset,
      }}
    >
      <Strips areTopStrips />
      {isPostFeed && (
        <FeedLayout>
          <ContentLoader>
            <BrowseThumbLayout
              getItemUrl={getItemUrl}
              contentStrip={contentStrip}
              contentStripIndex={contentStripIndex}
              contentStripHeight={contentStripHeight}
            />
          </ContentLoader>
        </FeedLayout>
      )}
      {!isPostFeed && (
        <ContentLoader>
          <BrowseThumbLayout
            getItemUrl={getItemUrl}
            contentStrip={contentStrip}
            contentStripIndex={contentStripIndex}
            contentStripHeight={contentStripHeight}
          />
        </ContentLoader>
      )}
    </BiLoggerContextProvider>
  );
};
DefaultPageContent.displayName = 'DefaultPageContent';

export default DefaultPageContent;
